import { connect } from 'react-redux';
import { FHC_MODULE_STATUSES } from '../../helpers/constants';
import { ManualCoach } from '../manual-coach-widget';
import { getStatusPlain, isModuleCompletedPlain } from '../../helpers/custom-page/is-completed';

const MESSAGES = {
  pensionFinderHasItems: {
    notStarted: `
      <p>Congratulation! You’ve created your timeline!</p>
      <p>Now, to find your lost pensions we'll go through 4 steps:<br>
      1 - Fill your job history timeline<br>
      2 - Find who was the provider of pension at the time of your employement.<br>
      3 - Generate a letter to request your information<br>
      4 - Input the data you have or you received in Pension Finder to help you plan for later.</p>
    `,
    inProgress: `
      <p>Excellent, you've added new job added to your timeline.</p>
      <p>Would you like to add another?</p>
    `,
    completed: `
      <p>Ok, the next step is to find the details of an unknown pension. It’s best to start with one that’s easy to find.</p>
      <p>I can help you create a letter to do this. Ready?</p>
    `
  },
  pensionFinderHasLetter: {
    completed: 'Done'
  }
};

const BUTTONS = {
  pensionFinderHasItems: {
    notStarted: {
      primaryButton: {
        name: 'Yes',
        link: '/checklist/pension-finder/company-name',
        activity: 'pensionFinderHasItems',
        status: FHC_MODULE_STATUSES.SEEN
      }
    },
    inProgress: {
      primaryButton: {
        name: 'Yes',
        link: '/checklist/pension-finder/company-name'
      },
      secondaryButton: {
        name: `No, that's all`,
        link: '/checklist/pension-finder/result',
        activity: 'pensionFinderHasItems',
        status: FHC_MODULE_STATUSES.COMPLETED
      }
    },
    completed: {
      primaryButton: {
        name: `Great, let’s continue`,
        link: '/checklist/pension-finder/letter-one-start',
        activity: 'pensionFinderHasLetter',
        status: FHC_MODULE_STATUSES.IN_PROGRESS
      },
      secondaryButton: {
        name: 'Remind me later',
        link: '/checklist'
      }
    }
  },
  pensionFinderHasLetter: {
    completed: {
      primaryButton: {
        name: '...'
      }
    }
  }
};

export const Coach = connect(({ statusData }) => {
  const {
    parsedStatuses,
    parsedStatuses: { pensionFinderHasItems, pensionFinderHasLetter }
  } = statusData;

  const activity = [pensionFinderHasItems, pensionFinderHasLetter].every(isModuleCompletedPlain)
    ? 'pensionFinderHasLetter'
    : 'pensionFinderHasItems';

  const status = getStatusPlain(parsedStatuses[activity]);

  const message = MESSAGES[activity][status] ?? MESSAGES[activity][FHC_MODULE_STATUSES.TO_DO];
  const buttons = BUTTONS[activity][status] ?? BUTTONS[activity][FHC_MODULE_STATUSES.TO_DO];

  return {
    message,
    ...buttons
  };
})(ManualCoach);
